import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=3488ccca&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=ts"
export * from "./Countdown.vue?vue&type=script&lang=ts"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=3488ccca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488ccca",
  null
  
)

export default component.exports